<div class="wm-tree-container">
  <wms-tree id="treeContent" name="wm-projectresources-tree" searchElementName="widget-search-search-field" [data]="pageStructureNodes"
            [preserveExpadedState]="true" (nodeClick)="handleClick($event)" (dataChanged)="onTreeDataChanged($event)" wms-feature="project.resources.files.project"
            [hasSearch]="true" class="list-type-tree" [expandByDefault]="true" [selectedNode]="selectedNode" [enableDragDrop]="true">
  </wms-tree>
</div>

